import React, { Fragment, useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import Select from "react-select";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddNotificationModal from "./AddNotificationModal";
import NotificationService from "../../../services/NotificationService";
import "./style.scss";

const typeOptions = [
	{ label: "Announcement", value: "announcement" },
	{ label: "General", value: "general" },
	{ label: "Warning", value: "warning" },
	{ label: "System", value: "system" },
];

const Notification = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [filterType, setFilterType] = useState(null);
	const lang = useSelector((state) => state.auth?.lang);

	const param = filterType ? { type: filterType.value } : {};

	return (
		<Fragment>
			<Card className="mb-3">
				<Card.Body className="search-card d-flex justify-content-between p-3 align-items-center">
					<div style={{ width: "250px" }}>
						<Select
							isClearable
							placeholder={Translate[lang]?.type}
							options={typeOptions}
							value={filterType}
							onChange={(e) => {
								setFilterType(e);
								setShouldUpdate((prev) => !prev);
							}}
						/>
					</div>
					<div className="add-department">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => setAddModal(true)}>
							<i className="la la-plus mx-1"></i>
							{Translate[lang]?.send} {Translate[lang]?.notification}
						</Button>
					</div>
				</Card.Body>
			</Card>

			<Row>
				<Col lg={12}>
					<Card>
						<Card.Body className={`${hasData === 0 && "text-center"}`}>
							{loading && (
								<div style={{ height: "300px" }}>
									<Loader />
								</div>
							)}
							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.title}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.message}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.type}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.date}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.actions}</strong>
											</th>
										</tr>
									</thead>
									<tbody className="table-body">
										{data?.map((item, index) => (
											<CardItem
												key={item.id || index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
											/>
										))}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={new NotificationService()}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								param={param}
							/>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{addModal && (
				<AddNotificationModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
				/>
			)}
		</Fragment>
	);
};

export default Notification;
